module.exports = "dist/logo_green.png?0f6f8cffb4b7ef657bdcfafeab29b3f3";